import React from 'react';

const Remark = ({ message }) => (
	<span style={{ color: "red", fontStyle: "italic" }}>
		{message}
	</span>
)

export default Remark;



// WEBPACK FOOTER //
// ./src/fw/components/remark/Remark.js